import { render, staticRenderFns } from "./Game5-16.vue?vue&type=template&id=09d6284c&scoped=true&"
import script from "./Game5-16.vue?vue&type=script&lang=js&"
export * from "./Game5-16.vue?vue&type=script&lang=js&"
import style0 from "./Game5-16.vue?vue&type=style&index=0&id=09d6284c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d6284c",
  null
  
)

export default component.exports